import CrudSection from "../components/CrudSection";
import PlaceholderSection from "../components/PlaceholderSection";
import { StatusTextBadge } from "../../../components/base/StatusTextBadge";
import type { CrudColumn, CrudField } from "../types";

// ===========================================================================
// Seguridad y vigilancia — secciones con datos de ejemplo que aún no pasan al API (las demás viven en ../screens, CC-CONSOLE #1593).
// ===========================================================================

// --- Reportes en campo -----------------------------------------------------
interface Reporte extends Record<string, unknown> {
  id: string; folio: string; titulo: string; reporta: string; tipo: string; estado: string;
}
const reporteColumns: CrudColumn<Reporte>[] = [
  { key: "folio", label: "Folio" },
  { key: "titulo", label: "Título" },
  { key: "reporta", label: "Reporta" },
  { key: "tipo", label: "Tipo" },
  { key: "estado", label: "Estado", align: "center", render: (r) => <StatusTextBadge value={r.estado} /> },
];
const reporteFields: CrudField[] = [
  { key: "titulo", label: "Título", required: true, placeholder: "Vehículo mal estacionado" },
  { key: "reporta", label: "Reporta", required: true, placeholder: "Guardia / personal" },
  { key: "tipo", label: "Tipo", type: "select", defaultValue: "Incidencia", options: [
    { value: "Incidencia", label: "Incidencia" }, { value: "Amonestación", label: "Amonestación" }, { value: "Mantenimiento", label: "Mantenimiento" },
  ] },
  { key: "folio", label: "Folio", placeholder: "Se genera automáticamente", defaultValue: "RPT-NUEVO" },
  { key: "estado", label: "Estado", type: "select", defaultValue: "Abierto", options: [
    { value: "Abierto", label: "Abierto" }, { value: "En proceso", label: "En proceso" }, { value: "Cerrado", label: "Cerrado" },
  ] },
  { key: "descripcion", label: "Descripción", type: "textarea", placeholder: "Detalle del reporte..." },
];
const reporteSeed: Reporte[] = [
  { id: "rp1", folio: "RPT-1042", titulo: "Vehículo mal estacionado", reporta: "M. Soto", tipo: "Amonestación", estado: "Abierto" },
  { id: "rp2", folio: "RPT-1041", titulo: "Luminaria dañada — Torre B", reporta: "L. Reyes", tipo: "Mantenimiento", estado: "En proceso" },
  { id: "rp3", folio: "RPT-1039", titulo: "Ruido excesivo Depto 510", reporta: "J. Mora", tipo: "Incidencia", estado: "Cerrado" },
];
export const ReportesCampoSection = () => (
  <CrudSection<Reporte> title="Reportes en campo" subtitle="Incidencias y amonestaciones del personal"
    icon="ri-file-warning-line" columns={reporteColumns} fields={reporteFields} seed={reporteSeed} searchKey="titulo" />
);

// --- Chat directo (view) ---------------------------------------------------
export const ChatDirectoSection = () => (
  <PlaceholderSection
    title="Chat directo"
    subtitle="Comunicación con comunidad, seguridad y soporte"
    icon="ri-chat-3-line"
    bullets={[
      "Canal directo entre residentes y personal de seguridad",
      "Mensajería con soporte de la plataforma",
      "Adjuntar fotos y ubicación a un reporte",
      "Historial de conversaciones por incidente",
    ]}
  />
);
